(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqQuestions = document.querySelectorAll('.faq-question');
    
    faqQuestions.forEach(question => {
      question.addEventListener('click', function() {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        const wrapper = this.nextElementSibling;
        if (!expanded) {
          faqQuestions.forEach(otherQuestion => {
            if (otherQuestion !== this) {
              otherQuestion.setAttribute('aria-expanded', 'false');
              otherQuestion.nextElementSibling.style.maxHeight = '0px';
            }
          });
        }
        
        if (expanded) {
          this.setAttribute('aria-expanded', 'false');
          wrapper.style.maxHeight = '0px';
        } else {
          this.setAttribute('aria-expanded', 'true');
          wrapper.style.maxHeight = wrapper.scrollHeight + 'px';
        }
      });
    });

    // Sidebar category navigation
    const navItems = document.querySelectorAll('.faq-wrap-nav li');
    let isProgrammaticScroll = false;
    let scrollEndTimer;

    function setActiveNavItem(handle) {
      navItems.forEach(item => {
        item.classList.toggle('is-active', item.dataset.handle === handle);
      });
    }

    navItems.forEach(item => {
      item.addEventListener('click', function() {
        const handle = this.dataset.handle;
        const target = document.getElementById('category-' + handle);
        if (target) {
          const offset = window.innerWidth >= 992 ? 123 : 172;
          const top = target.getBoundingClientRect().top + window.scrollY - offset;
          isProgrammaticScroll = true;
          setActiveNavItem(handle);
          window.scrollTo({ top, behavior: 'smooth' });
        }
      });
    });

    window.addEventListener('scroll', function() {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(function() {
        isProgrammaticScroll = false;
      }, 150);
    }, { passive: true });

    // IntersectionObserver: highlight active sidebar category based on scroll
    const categoryGroups = document.querySelectorAll('.faq-category-group');
    const intersecting = new Set();

    const stickyOffset = window.innerWidth >= 992 ? 123 : 172;
    const rootMarginTop = '-' + stickyOffset + 'px';

    const categoryObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          intersecting.add(entry.target);
        } else {
          intersecting.delete(entry.target);
        }
      });

      if (isProgrammaticScroll) return;

      if (intersecting.size > 0) {
        const topmost = Array.from(intersecting).reduce(function(a, b) {
          return a.getBoundingClientRect().top <= b.getBoundingClientRect().top ? a : b;
        });
        setActiveNavItem(topmost.id.replace('category-', ''));
      }
    }, {
      rootMargin: rootMarginTop + ' 0px -60% 0px',
      threshold: 0
    });

    categoryGroups.forEach(function(group) {
      categoryObserver.observe(group);
    });

    if (window.location.hash) {
      const id = window.location.hash.substring(1);
      const target = document.getElementById(id);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 500);
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-banner"] && !Shopify.designMode) return;
  try {
    
  function mainBannerCarouselInit() {
    var sections = document.querySelectorAll('.main-banner-carousel');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var wrapper = section.querySelector('.main-banner-inr.swiper');
      if (!wrapper || wrapper.swiper) return;

      var swiperOptions = {
        loop: true,
        grabCursor: true,
        navigation: {
          nextEl: section.querySelector('.swiper-button-next'),
          prevEl: section.querySelector('.swiper-button-prev'),
        },
      };

      if (wrapper.dataset.autoplayDelay) {
        swiperOptions.autoplay = {
          delay: parseInt(wrapper.dataset.autoplayDelay, 10),
          disableOnInteraction: false,
        };
      }

      var swiper = new Swiper(wrapper, swiperOptions);
      var toggle = section.querySelector('.mbnr-carousel-toggle');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var wasRunning = swiper.autoplay.running;
        if (wasRunning) {
          swiper.autoplay.stop();
        } else {
          swiper.autoplay.start();
        }
        toggle.classList.toggle('is-paused', wasRunning);
        toggle.setAttribute('aria-pressed', String(wasRunning));
        toggle.setAttribute('aria-label', wasRunning ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mainBannerCarouselInit);
  } else {
    mainBannerCarouselInit();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target.querySelector('.main-banner-carousel')) {
        mainBannerCarouselInit();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }    		
              var productslider=[];
              document.querySelectorAll('.product-carousel').forEach(function(Element,index){    
                let productid = Element.dataset.id;
                let outer_carousel = Element.closest('.carousel-rowouter');
                let nextbutton = outer_carousel.querySelectorAll('.swiper-button-next')[0];
                let prevbutton = outer_carousel.querySelectorAll('.swiper-button-prev')[0];
                let swiperObject={
                  loop:eval(Element.dataset.loop),
                  slidesPerView: "auto",
                  navigation: {
                    nextEl:nextbutton,
                    prevEl:prevbutton,
                  },
                };    
                productslider[productid]=new Swiper(Element,swiperObject);
              }); 
              if(typeof quickAddButton == 'function'){
              quickAddButton();
              }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
